// static paths
export const paths = {
    ENTRY_PAGE: '/',
    SIGN_IN: 'sign-in',
    SIGN_UP: 'sign-up',
    SIGN_UP_EMAIL: 'sign-up-email',
    SIGN_UP_GYM: 'sign-up-gym',
    RESET_PASSWORD: 'reset-password',
};

export const externalLinks = {
    TERMS_AND_CONDITIONS: 'https://www.tona.fit/termsandconditions',
    PRIVACY_POLICY: 'https://www.tona.fit/privacypolicy',
    TONAFIT_LINK: 'https://www.tona.fit/',
};



// WEBPACK FOOTER //
// ./src/Constants/paths.js